import { UseI18n } from '../../../../../common/hooks/useI18n'
import { Icon } from '../../../../../common/html/icon'

export const Item = ({ item }) => {
  const title = UseI18n(item.label)
  const lockAction = item.lockAction || (() => {})

  return (
    <Icon
      title={title}
      className={item.iconClass}
      style={{
        ...item,
        padding: 4,
        borderRadius: '50%',
        marginRight: 4,
        fontSize: 15,
      }}
      onClick={item.isLock ? lockAction : item.action}
    />
  )
}
